import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/payments/payment/:paymentId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    paymentId: string;
}
const mutationFn = ({ paymentId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { paymentId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeletePayment };
